import { type AnalyticsPlugin } from "analytics";

// Declare Segment analytics global
declare global {
  interface Window {
    analytics?: {
      page: (...args: any[]) => void;
      track: (event: string, properties?: Record<string, any>) => void;
      identify: (userId: string, traits?: Record<string, any>) => void;
      reset: () => void;
    };
  }
}

/**
 * Segment tracking plugin that uses window.analytics loaded by ConsentBasedSegment component.
 * This plugin only handles event tracking - script loading is done by the component.
 */
export const segmentTrackingPlugin: AnalyticsPlugin = {
  name: 'segment-tracking',

  // No initialization needed - script loaded by component
  initialize: () => {
    // No-op: Script loading handled by ConsentBasedSegment component in layout.tsx
  },

  page: ({ payload }) => {
    if (typeof window !== 'undefined' && window.analytics) {
      window.analytics.page(payload.title, {
        path: payload.path,
        url: typeof window !== 'undefined' ? window.location.href : undefined,
        ...payload.properties,
      });
    }
  },

  track: ({ payload }) => {
    if (typeof window !== 'undefined' && window.analytics) {
      const { event, properties = {} } = payload;
      window.analytics.track(event, properties);
    }
  },

  identify: ({ payload }) => {
    if (typeof window !== 'undefined' && window.analytics) {
      const { userId, traits = {} } = payload;
      if (userId) {
        window.analytics.identify(userId, traits);
      }
    }
  },

  reset: () => {
    if (typeof window !== 'undefined' && window.analytics) {
      window.analytics.reset();
    }
  },
};
